export const waInstallsData = [
  {
    "name": "Albany",
    "value": 1,
    "lat": -35.0247822,
    "lng": 117.883608
  },
  {
    "name": "Alexander Heights",
    "value": 1,
    "lat": -31.8271578,
    "lng": 115.865815
  },
  {
    "name": "Alkimos",
    "value": 22,
    "lat": -31.6154224,
    "lng": 115.6926511
  },
  {
    "name": "Alkimos Central",
    "value": 1,
    "lat": -31.6154224,
    "lng": 115.6926511
  },
  {
    "name": "Anketell",
    "value": 3,
    "lat": -32.2197553,
    "lng": 115.8667368
  },
  {
    "name": "Applecross",
    "value": 5,
    "lat": -32.0137091,
    "lng": 115.8366566
  },
  {
    "name": "Ardross",
    "value": 4,
    "lat": -32.0271228,
    "lng": 115.8355245
  },
  {
    "name": "Armadale",
    "value": 14,
    "lat": -32.152266,
    "lng": 116.0147457
  },
  {
    "name": "Armidale",
    "value": 2,
    "lat": -30.697461589047386,
    "lng": 152.09000388400918
  },
  {
    "name": "Ascot",
    "value": 2,
    "lat": -31.9349899,
    "lng": 115.92078387595244
  },
  {
    "name": "Ashby",
    "value": 3,
    "lat": -31.7311903,
    "lng": 115.7975644
  },
  {
    "name": "Attadale",
    "value": 1,
    "lat": -32.025346,
    "lng": 115.8023457
  },
  {
    "name": "Atwell",
    "value": 1,
    "lat": -32.144216549999996,
    "lng": 115.86413385983938
  },
  {
    "name": "Aubin Grove",
    "value": 1,
    "lat": -32.1549359,
    "lng": 115.85795
  },
  {
    "name": "Australind",
    "value": 13,
    "lat": -33.2807362,
    "lng": 115.7204483
  },
  {
    "name": "Aveley",
    "value": 3,
    "lat": -31.787069,
    "lng": 115.9862261
  },
  {
    "name": "Balcatta",
    "value": 5,
    "lat": -31.8748729,
    "lng": 115.81297059805215
  },
  {
    "name": "Baldivis",
    "value": 14,
    "lat": -32.3299121,
    "lng": 115.8218124
  },
  {
    "name": "Balga",
    "value": 1,
    "lat": -31.852762,
    "lng": 115.84644694727552
  },
  {
    "name": "Balingup",
    "value": 3,
    "lat": -33.7860758,
    "lng": 115.9831595
  },
  {
    "name": "Ballajura",
    "value": 2,
    "lat": -31.8494104,
    "lng": 115.9221151
  },
  {
    "name": "Banksia Grove",
    "value": 5,
    "lat": -31.6954676,
    "lng": 115.8034438
  },
  {
    "name": "Baskerville",
    "value": 1,
    "lat": -31.7969218,
    "lng": 116.0469782
  },
  {
    "name": "Bassendean",
    "value": 5,
    "lat": -31.9031462,
    "lng": 115.9559295
  },
  {
    "name": "Bateman",
    "value": 1,
    "lat": -32.055541,
    "lng": 115.8472485
  },
  {
    "name": "Bayswater",
    "value": 9,
    "lat": -31.909036,
    "lng": 115.90391349431482
  },
  {
    "name": "Beaconsfield",
    "value": 4,
    "lat": -32.0693877,
    "lng": 115.768587
  },
  {
    "name": "Beckenham",
    "value": 1,
    "lat": -32.0215834,
    "lng": 115.9648379
  },
  {
    "name": "Bedford",
    "value": 1,
    "lat": -31.9101207,
    "lng": 115.8915315
  },
  {
    "name": "Bedfordale",
    "value": 2,
    "lat": -32.179239,
    "lng": 116.0652304
  },
  {
    "name": "Beechboro",
    "value": 4,
    "lat": -31.8695832,
    "lng": 115.9374824
  },
  {
    "name": "Beldon",
    "value": 1,
    "lat": -31.77378,
    "lng": 115.7682
  },
  {
    "name": "Bellevue",
    "value": 1,
    "lat": -31.9015253,
    "lng": 116.0288929
  },
  {
    "name": "Belmont",
    "value": 6,
    "lat": -31.9462298,
    "lng": 115.9336781
  },
  {
    "name": "Bennett Springs",
    "value": 10,
    "lat": -31.85781029345614,
    "lng": 115.95302525919931
  },
  {
    "name": "Bentley",
    "value": 9,
    "lat": -32.0084461,
    "lng": 115.9065455
  },
  {
    "name": "Bertram",
    "value": 1,
    "lat": -32.2452415,
    "lng": 115.844506
  },
  {
    "name": "Beverley",
    "value": 1,
    "lat": -32.1076853,
    "lng": 116.9256264
  },
  {
    "name": "Bibra Lake",
    "value": 5,
    "lat": -32.0992868,
    "lng": 115.8185072
  },
  {
    "name": "Bicton",
    "value": 2,
    "lat": -32.0265247,
    "lng": 115.785885
  },
  {
    "name": "Birchmont",
    "value": 1,
    "lat": -32.7189975,
    "lng": 115.7296807401766
  },
  {
    "name": "Boddington",
    "value": 1,
    "lat": -32.8023099,
    "lng": 116.475076
  },
  {
    "name": "Boulder",
    "value": 1,
    "lat": -30.787752,
    "lng": 121.4556635
  },
  {
    "name": "Brabham",
    "value": 4,
    "lat": -31.8283583,
    "lng": 115.9764153
  },
  {
    "name": "Brentwood",
    "value": 3,
    "lat": -32.0435208,
    "lng": 115.8524477
  },
  {
    "name": "Broadwater",
    "value": 1,
    "lat": -33.66047,
    "lng": 115.2865
  },
  {
    "name": "Bull Creek",
    "value": 1,
    "lat": -32.0562543,
    "lng": 115.8624527
  },
  {
    "name": "Bullsbrook",
    "value": 18,
    "lat": -31.660562849999998,
    "lng": 116.03357969757423
  },
  {
    "name": "Bunbury",
    "value": 38,
    "lat": -33.3267797,
    "lng": 115.636698
  },
  {
    "name": "Burns Beach",
    "value": 1,
    "lat": -31.7282352,
    "lng": 115.7199225
  },
  {
    "name": "Burswood",
    "value": 21,
    "lat": -31.9602196,
    "lng": 115.8962701
  },
  {
    "name": "Burswood Park",
    "value": 1,
    "lat": -31.9602196,
    "lng": 115.8962701
  },
  {
    "name": "Busselton",
    "value": 1,
    "lat": -33.644499,
    "lng": 115.3488754
  },
  {
    "name": "Butler",
    "value": 6,
    "lat": -31.6356944,
    "lng": 115.7003262
  },
  {
    "name": "Byford",
    "value": 27,
    "lat": -32.2160061,
    "lng": 116.01467
  },
  {
    "name": "Byfortd",
    "value": 1,
    "lat": -25.2303005,
    "lng": 121.0187246
  },
  {
    "name": "Canning Vale",
    "value": 13,
    "lat": -32.0813818,
    "lng": 115.916882
  },
  {
    "name": "Cannington",
    "value": 1,
    "lat": -32.0134373,
    "lng": 115.9449495
  },
  {
    "name": "Capel",
    "value": 1,
    "lat": -33.55125,
    "lng": 115.5615253
  },
  {
    "name": "Cardup",
    "value": 4,
    "lat": -32.2543603,
    "lng": 115.9853125
  },
  {
    "name": "Carey Park",
    "value": 3,
    "lat": -33.35420005,
    "lng": 115.65325234598906
  },
  {
    "name": "Carine",
    "value": 1,
    "lat": -31.85234295,
    "lng": 115.77592737349457
  },
  {
    "name": "Carmel",
    "value": 2,
    "lat": -32.0217696,
    "lng": 116.0830987
  },
  {
    "name": "Casuarina",
    "value": 7,
    "lat": -32.2429301,
    "lng": 115.866906
  },
  {
    "name": "Caversham",
    "value": 4,
    "lat": -31.8750099,
    "lng": 115.9748193
  },
  {
    "name": "Champion Lakes",
    "value": 9,
    "lat": -32.117917,
    "lng": 115.987317
  },
  {
    "name": "Chidlow",
    "value": 1,
    "lat": -31.859595,
    "lng": 116.2687417
  },
  {
    "name": "Chittering",
    "value": 1,
    "lat": -31.46766,
    "lng": 116.0801
  },
  {
    "name": "City Beach",
    "value": 6,
    "lat": -31.9364674,
    "lng": 115.7599058
  },
  {
    "name": "Claremont",
    "value": 18,
    "lat": -31.950651999999998,
    "lng": 115.79787549213657
  },
  {
    "name": "Claremont Showground",
    "value": 1,
    "lat": -31.974850250000003,
    "lng": 115.78558052466971
  },
  {
    "name": "Clarkson",
    "value": 7,
    "lat": -31.6906707,
    "lng": 115.7380776
  },
  {
    "name": "Cloverdale",
    "value": 1,
    "lat": -31.9624358,
    "lng": 115.9447482
  },
  {
    "name": "Cockburn Central",
    "value": 6,
    "lat": -32.1253324,
    "lng": 115.8583575
  },
  {
    "name": "College Grove",
    "value": 2,
    "lat": -33.3740061,
    "lng": 115.6608494
  },
  {
    "name": "Collie",
    "value": 2,
    "lat": -33.3591223,
    "lng": 116.1536169
  },
  {
    "name": "Como",
    "value": 6,
    "lat": -31.999702,
    "lng": 115.8676543
  },
  {
    "name": "Connolly",
    "value": 1,
    "lat": -31.747944,
    "lng": 115.7497916
  },
  {
    "name": "Coodanup",
    "value": 2,
    "lat": -32.5450737,
    "lng": 115.7489665
  },
  {
    "name": "Coogee",
    "value": 1,
    "lat": -32.121836,
    "lng": 115.7684345
  },
  {
    "name": "Coolbellup",
    "value": 3,
    "lat": -32.0812445,
    "lng": 115.8060784
  },
  {
    "name": "Cooloongup",
    "value": 2,
    "lat": -32.2966958,
    "lng": 115.7685636
  },
  {
    "name": "Cottesloe",
    "value": 7,
    "lat": -31.9955715,
    "lng": 115.7558367
  },
  {
    "name": "Craigie",
    "value": 1,
    "lat": -31.7815603,
    "lng": 115.7710675
  },
  {
    "name": "Cullalla",
    "value": 1,
    "lat": -31.2216875,
    "lng": 115.99755688652002
  },
  {
    "name": "Currambine",
    "value": 2,
    "lat": -31.7354623,
    "lng": 115.7456718
  },
  {
    "name": "Daglish",
    "value": 4,
    "lat": -31.9517991,
    "lng": 115.8134022
  },
  {
    "name": "Dalkeith",
    "value": 7,
    "lat": -31.9956976,
    "lng": 115.7999434
  },
  {
    "name": "Dalwallinu",
    "value": 1,
    "lat": -30.2762899,
    "lng": 116.6628036
  },
  {
    "name": "Dalyellup",
    "value": 6,
    "lat": -33.410681,
    "lng": 115.61313525149313
  },
  {
    "name": "Darch",
    "value": 3,
    "lat": -31.812791,
    "lng": 115.84525258388967
  },
  {
    "name": "Darling Downs",
    "value": 19,
    "lat": -27.1170905,
    "lng": 150.8946407562599
  },
  {
    "name": "Davenport",
    "value": 6,
    "lat": -33.379246,
    "lng": 115.68800202225961
  },
  {
    "name": "Dawesville",
    "value": 1,
    "lat": -32.6342692,
    "lng": 115.638048
  },
  {
    "name": "Dayton",
    "value": 5,
    "lat": -31.8557737,
    "lng": 115.9740664
  },
  {
    "name": "Dianella",
    "value": 5,
    "lat": -31.8941978,
    "lng": 115.8714367
  },
  {
    "name": "Donnybrook",
    "value": 3,
    "lat": -33.5773757,
    "lng": 115.8251293
  },
  {
    "name": "Doubleview",
    "value": 6,
    "lat": -31.8951465,
    "lng": 115.7786901
  },
  {
    "name": "Duncraig",
    "value": 6,
    "lat": -31.821907799999998,
    "lng": 115.76757079752755
  },
  {
    "name": "Dunsborough",
    "value": 3,
    "lat": -33.614656,
    "lng": 115.1065921
  },
  {
    "name": "Dwellingup",
    "value": 1,
    "lat": -32.7116497,
    "lng": 116.0680276
  },
  {
    "name": "East Bunbury",
    "value": 5,
    "lat": -33.338536500000004,
    "lng": 115.6582483270631
  },
  {
    "name": "East Cannington",
    "value": 2,
    "lat": -32.0134373,
    "lng": 115.9449495
  },
  {
    "name": "East Fremantle",
    "value": 3,
    "lat": -32.035363000000004,
    "lng": 115.76878040412583
  },
  {
    "name": "East Perth",
    "value": 13,
    "lat": -31.954341,
    "lng": 115.8778894
  },
  {
    "name": "East Rockingham",
    "value": 8,
    "lat": -32.2576602,
    "lng": 115.7741388
  },
  {
    "name": "East Victoria Park",
    "value": 9,
    "lat": -31.9842427,
    "lng": 115.9028513
  },
  {
    "name": "Eaton",
    "value": 13,
    "lat": -33.3086615,
    "lng": 115.72464546962061
  },
  {
    "name": "Eglinton",
    "value": 2,
    "lat": -31.5836681,
    "lng": 115.6725389
  },
  {
    "name": "Ellenbrook",
    "value": 18,
    "lat": -31.7816019,
    "lng": 115.96339
  },
  {
    "name": "Embleton",
    "value": 1,
    "lat": -31.90378,
    "lng": 115.9104
  },
  {
    "name": "Eneabba",
    "value": 1,
    "lat": -29.8184486,
    "lng": 115.27246
  },
  {
    "name": "Erskine",
    "value": 1,
    "lat": -32.5624396,
    "lng": 115.6894254
  },
  {
    "name": "Esperance",
    "value": 2,
    "lat": -33.858228,
    "lng": 121.8931606
  },
  {
    "name": "FORRESTFIELD",
    "value": 10,
    "lat": -31.9858122,
    "lng": 116.0075629
  },
  {
    "name": "Falcon",
    "value": 1,
    "lat": -32.5850645,
    "lng": 115.6700331634089
  },
  {
    "name": "Floreat",
    "value": 7,
    "lat": -31.9392096,
    "lng": 115.7939626
  },
  {
    "name": "Forrestdale",
    "value": 33,
    "lat": -32.1504796,
    "lng": 115.9378093
  },
  {
    "name": "Fremantle",
    "value": 40,
    "lat": -32.0534086,
    "lng": 115.7586172
  },
  {
    "name": "Furnissdale",
    "value": 5,
    "lat": -32.5596515,
    "lng": 115.7721837
  },
  {
    "name": "Garden Island",
    "value": 3,
    "lat": -32.199901,
    "lng": 115.67630484149223
  },
  {
    "name": "Gearldton",
    "value": 1,
    "lat": -25.2303005,
    "lng": 121.0187246
  },
  {
    "name": "Geraldton",
    "value": 1,
    "lat": -28.77035,
    "lng": 114.6147159
  },
  {
    "name": "Gidgegannup",
    "value": 2,
    "lat": -31.7932274,
    "lng": 116.1960296
  },
  {
    "name": "Gingin",
    "value": 2,
    "lat": -31.3441233,
    "lng": 115.9076557
  },
  {
    "name": "Ginginup",
    "value": 2,
    "lat": -31.2964,
    "lng": 115.91790754515102
  },
  {
    "name": "Girraween",
    "value": 7,
    "lat": -32.14827109132953,
    "lng": 115.9926008772499
  },
  {
    "name": "Glen Iris",
    "value": 4,
    "lat": -33.3414485,
    "lng": 115.68291534898025
  },
  {
    "name": "Glendalough",
    "value": 1,
    "lat": -31.9151316,
    "lng": 115.8231889
  },
  {
    "name": "Gnangara",
    "value": 1,
    "lat": -31.7752884,
    "lng": 115.8649195
  },
  {
    "name": "Golden Bay",
    "value": 3,
    "lat": -32.4292934,
    "lng": 115.7557307
  },
  {
    "name": "Gooseberry Hill",
    "value": 1,
    "lat": -31.94035615,
    "lng": 116.04980889541405
  },
  {
    "name": "Gosnells",
    "value": 25,
    "lat": -32.0673135,
    "lng": 115.99773042056074
  },
  {
    "name": "Greenbushes",
    "value": 3,
    "lat": -33.8494245,
    "lng": 116.0595868
  },
  {
    "name": "Greenfields",
    "value": 6,
    "lat": -32.5234919,
    "lng": 115.7622058
  },
  {
    "name": "Greenmount",
    "value": 1,
    "lat": -31.91036005,
    "lng": 116.0629829761645
  },
  {
    "name": "Greenwood",
    "value": 3,
    "lat": -31.826829150000002,
    "lng": 115.79143911925067
  },
  {
    "name": "Guildford",
    "value": 4,
    "lat": -31.8985059,
    "lng": 115.9702294
  },
  {
    "name": "Gwelup",
    "value": 1,
    "lat": -31.87156,
    "lng": 115.7993
  },
  {
    "name": "Halls Head",
    "value": 3,
    "lat": -32.5408801,
    "lng": 115.6987381
  },
  {
    "name": "Hamersley",
    "value": 1,
    "lat": -22.984,
    "lng": 118.587
  },
  {
    "name": "Hamilton Hill",
    "value": 2,
    "lat": -32.0845215,
    "lng": 115.7794833
  },
  {
    "name": "Hammond Park",
    "value": 4,
    "lat": -32.17362915,
    "lng": 115.85095473628382
  },
  {
    "name": "Hammond Park WA",
    "value": 1,
    "lat": -32.1619004,
    "lng": 115.8469467
  },
  {
    "name": "Harrisdale",
    "value": 3,
    "lat": -32.1186965,
    "lng": 115.9314593
  },
  {
    "name": "Harvey",
    "value": 1,
    "lat": -33.0806518,
    "lng": 115.8984193
  },
  {
    "name": "Haynes",
    "value": 6,
    "lat": -32.1542999,
    "lng": 115.9772969
  },
  {
    "name": "Hazelmere",
    "value": 9,
    "lat": -31.9109095,
    "lng": 116.0030678
  },
  {
    "name": "Heathridge",
    "value": 3,
    "lat": -31.7585,
    "lng": 115.7606
  },
  {
    "name": "Helena Valley",
    "value": 14,
    "lat": -31.9204975,
    "lng": 116.0385035
  },
  {
    "name": "Henderson",
    "value": 14,
    "lat": -32.1625849,
    "lng": 115.7779342
  },
  {
    "name": "High Wycombe",
    "value": 10,
    "lat": -31.954628,
    "lng": 115.9921995
  },
  {
    "name": "Hilbert",
    "value": 12,
    "lat": -32.1719378,
    "lng": 115.9784985
  },
  {
    "name": "Hillarys",
    "value": 6,
    "lat": -31.8097006,
    "lng": 115.7487831
  },
  {
    "name": "Hillman",
    "value": 2,
    "lat": -32.2817125,
    "lng": 115.7680486
  },
  {
    "name": "Hope Valley",
    "value": 14,
    "lat": -32.196020000000004,
    "lng": 115.81370988070697
  },
  {
    "name": "Huntingdale",
    "value": 2,
    "lat": -32.0831297,
    "lng": 115.96615
  },
  {
    "name": "Inglewood",
    "value": 2,
    "lat": -31.9188613,
    "lng": 115.8835111
  },
  {
    "name": "Innaloo",
    "value": 5,
    "lat": -31.8937756,
    "lng": 115.7957972
  },
  {
    "name": "Jandakot",
    "value": 22,
    "lat": -32.0976113,
    "lng": 115.87474821252181
  },
  {
    "name": "Jarrahdale",
    "value": 2,
    "lat": -32.327447500000005,
    "lng": 116.0466849045638
  },
  {
    "name": "Jelcobine",
    "value": 1,
    "lat": -32.40683,
    "lng": 116.7662
  },
  {
    "name": "Jindalee",
    "value": 3,
    "lat": -31.6510271,
    "lng": 115.6924119
  },
  {
    "name": "Jolimont",
    "value": 3,
    "lat": -31.94656,
    "lng": 115.8095
  },
  {
    "name": "Joondalup",
    "value": 9,
    "lat": -31.7430766,
    "lng": 115.7721181
  },
  {
    "name": "Joondanna",
    "value": 1,
    "lat": -31.9100664,
    "lng": 115.8365834
  },
  {
    "name": "Jurien Bay",
    "value": 1,
    "lat": -30.3040478,
    "lng": 115.0406027
  },
  {
    "name": "KINGS PARK",
    "value": 3,
    "lat": -31.9641655,
    "lng": 115.8387477
  },
  {
    "name": "Kalgoorlie",
    "value": 7,
    "lat": -30.7464139,
    "lng": 121.473223
  },
  {
    "name": "Kallaroo",
    "value": 6,
    "lat": -31.7907815,
    "lng": 115.7451137
  },
  {
    "name": "Karawara",
    "value": 1,
    "lat": -32.0086201,
    "lng": 115.8812666
  },
  {
    "name": "Kardinya",
    "value": 7,
    "lat": -32.0655873,
    "lng": 115.8148419
  },
  {
    "name": "Karratha",
    "value": 2,
    "lat": -20.7370067,
    "lng": 116.8478592
  },
  {
    "name": "Karrinyup",
    "value": 4,
    "lat": -31.8705761,
    "lng": 115.7787989
  },
  {
    "name": "Katanning",
    "value": 3,
    "lat": -33.6908682,
    "lng": 117.5551858
  },
  {
    "name": "Kelmscott",
    "value": 11,
    "lat": -32.1164024,
    "lng": 116.0163062
  },
  {
    "name": "Kelmscott WA 6111",
    "value": 2,
    "lat": -32.1213674,
    "lng": 116.0109558
  },
  {
    "name": "Kenwick",
    "value": 17,
    "lat": -32.033881,
    "lng": 115.9847507
  },
  {
    "name": "Kewdale",
    "value": 10,
    "lat": -31.9760687,
    "lng": 115.9423314
  },
  {
    "name": "Kingsley",
    "value": 3,
    "lat": -31.8087122,
    "lng": 115.7975502
  },
  {
    "name": "Koondoola",
    "value": 1,
    "lat": -31.8424891,
    "lng": 115.8638624
  },
  {
    "name": "Kumarina",
    "value": 1,
    "lat": -24.7130064,
    "lng": 119.6061945
  },
  {
    "name": "Kwinana",
    "value": 4,
    "lat": -32.233854,
    "lng": 115.82114839519188
  },
  {
    "name": "Kwinana Beach",
    "value": 8,
    "lat": -32.2266186,
    "lng": 115.7763707
  },
  {
    "name": "Lake Coogee",
    "value": 1,
    "lat": -32.1280377,
    "lng": 115.7787262
  },
  {
    "name": "Lakelands",
    "value": 15,
    "lat": -32.4736812,
    "lng": 115.7705224
  },
  {
    "name": "Lancelin",
    "value": 6,
    "lat": -31.0225285,
    "lng": 115.3301909
  },
  {
    "name": "Landsdale",
    "value": 7,
    "lat": -31.809048,
    "lng": 115.8662569
  },
  {
    "name": "Langford",
    "value": 1,
    "lat": -32.0411222,
    "lng": 115.9414671
  },
  {
    "name": "Lathlain",
    "value": 2,
    "lat": -31.972677750000003,
    "lng": 115.90819998512842
  },
  {
    "name": "Leda",
    "value": 2,
    "lat": -32.2645855,
    "lng": 115.8022344
  },
  {
    "name": "Leederville",
    "value": 2,
    "lat": -31.935301199999998,
    "lng": 115.8438119268822
  },
  {
    "name": "Leeming",
    "value": 1,
    "lat": -32.0757784,
    "lng": 115.8672721
  },
  {
    "name": "Lesmurdie",
    "value": 2,
    "lat": -32.0124634,
    "lng": 116.05152590979117
  },
  {
    "name": "Lockridge",
    "value": 1,
    "lat": -31.881459,
    "lng": 115.9499826
  },
  {
    "name": "Lower Chittering",
    "value": 1,
    "lat": -31.57155,
    "lng": 116.099
  },
  {
    "name": "Lynwood",
    "value": 1,
    "lat": -32.04104605,
    "lng": 115.91711535180022
  },
  {
    "name": "Maddington",
    "value": 18,
    "lat": -32.0493729,
    "lng": 115.982936
  },
  {
    "name": "Madeley",
    "value": 3,
    "lat": -31.8120053,
    "lng": 115.8252784
  },
  {
    "name": "Madora Bay",
    "value": 6,
    "lat": -32.4685295,
    "lng": 115.748503
  },
  {
    "name": "Madora Bay WA",
    "value": 2,
    "lat": -32.4685295,
    "lng": 115.748503
  },
  {
    "name": "Maida Vale",
    "value": 3,
    "lat": -31.9630972,
    "lng": 116.0273087
  },
  {
    "name": "Malaga",
    "value": 15,
    "lat": -31.8606948,
    "lng": 115.894192
  },
  {
    "name": "Mandogalup",
    "value": 7,
    "lat": -32.1952275,
    "lng": 115.84544076806927
  },
  {
    "name": "Mandurah",
    "value": 4,
    "lat": -32.5302495,
    "lng": 115.7208782
  },
  {
    "name": "Manjimup",
    "value": 1,
    "lat": -34.2410278,
    "lng": 116.1462983
  },
  {
    "name": "Mardella",
    "value": 3,
    "lat": -32.321405,
    "lng": 115.9450114
  },
  {
    "name": "Margaret River",
    "value": 1,
    "lat": -33.9531776,
    "lng": 115.0769369
  },
  {
    "name": "Mariginiup",
    "value": 5,
    "lat": -31.7215569,
    "lng": 115.8276065
  },
  {
    "name": "Martin",
    "value": 4,
    "lat": -32.0708796,
    "lng": 116.0595798
  },
  {
    "name": "Melville",
    "value": 3,
    "lat": -32.043096500000004,
    "lng": 115.81805254810521
  },
  {
    "name": "Merredin",
    "value": 1,
    "lat": -31.4813329,
    "lng": 118.2779117
  },
  {
    "name": "Merriwa",
    "value": 1,
    "lat": -31.6656152,
    "lng": 115.7125031
  },
  {
    "name": "Middle Swan",
    "value": 7,
    "lat": -31.8599389,
    "lng": 116.0180672
  },
  {
    "name": "Midland",
    "value": 7,
    "lat": -31.8890099,
    "lng": 116.002453
  },
  {
    "name": "Midvale",
    "value": 6,
    "lat": -31.8863833,
    "lng": 116.0268514
  },
  {
    "name": "Millbridge",
    "value": 1,
    "lat": -33.3065622,
    "lng": 115.7376502
  },
  {
    "name": "Millendon",
    "value": 1,
    "lat": -31.8074624,
    "lng": 116.0377085
  },
  {
    "name": "Mindarie",
    "value": 3,
    "lat": -31.676831749999998,
    "lng": 115.70597133320187
  },
  {
    "name": "Mirrabooka",
    "value": 9,
    "lat": -31.8629562,
    "lng": 115.8642381
  },
  {
    "name": "Morgantown",
    "value": 1,
    "lat": -24.87234,
    "lng": 113.6628
  },
  {
    "name": "Morley",
    "value": 16,
    "lat": -31.8934573,
    "lng": 115.9030854
  },
  {
    "name": "Mosman Park",
    "value": 10,
    "lat": -32.00781,
    "lng": 115.7680123
  },
  {
    "name": "Mount Claremont",
    "value": 3,
    "lat": -31.9644405,
    "lng": 115.7820352
  },
  {
    "name": "Mount Hawthorn",
    "value": 3,
    "lat": -31.9216585,
    "lng": 115.8328474
  },
  {
    "name": "Mount Helena",
    "value": 4,
    "lat": -31.8778804,
    "lng": 116.2093475
  },
  {
    "name": "Mount Lawley",
    "value": 1,
    "lat": -31.9281981,
    "lng": 115.8767714
  },
  {
    "name": "Mount Nasura",
    "value": 2,
    "lat": -32.1378332,
    "lng": 116.0276574
  },
  {
    "name": "Mount Pleasant",
    "value": 2,
    "lat": -32.028214,
    "lng": 115.8489476
  },
  {
    "name": "Muchea",
    "value": 6,
    "lat": -31.5809895,
    "lng": 115.9733169
  },
  {
    "name": "Mullaloo",
    "value": 3,
    "lat": -31.777283,
    "lng": 115.7427465
  },
  {
    "name": "Mullewa",
    "value": 1,
    "lat": -28.5390992,
    "lng": 115.514115
  },
  {
    "name": "Mundaring",
    "value": 2,
    "lat": -31.883877,
    "lng": 116.19406770281651
  },
  {
    "name": "Mundijong",
    "value": 11,
    "lat": -32.2958316,
    "lng": 115.9851981
  },
  {
    "name": "Munster",
    "value": 5,
    "lat": -32.1439552,
    "lng": 115.8012822
  },
  {
    "name": "Murdoch",
    "value": 17,
    "lat": -32.06741575,
    "lng": 115.83460861146293
  },
  {
    "name": "Myaree",
    "value": 6,
    "lat": -32.0428897,
    "lng": 115.8194409
  },
  {
    "name": "Nambeelup",
    "value": 1,
    "lat": -32.5082205,
    "lng": 115.8639921
  },
  {
    "name": "Nannup",
    "value": 1,
    "lat": -33.9784295,
    "lng": 115.7637655
  },
  {
    "name": "Narrogin",
    "value": 1,
    "lat": -32.9341978,
    "lng": 117.1778676
  },
  {
    "name": "Naval Base",
    "value": 3,
    "lat": -32.1954475,
    "lng": 115.7819194
  },
  {
    "name": "Nedlands",
    "value": 11,
    "lat": -31.9799209,
    "lng": 115.8057167
  },
  {
    "name": "Neerabup",
    "value": 22,
    "lat": -31.70798295,
    "lng": 115.75191835167551
  },
  {
    "name": "Newman",
    "value": 5,
    "lat": -23.4178009,
    "lng": 119.8030015
  },
  {
    "name": "Nollamara",
    "value": 5,
    "lat": -31.8804371,
    "lng": 115.843598
  },
  {
    "name": "Noranda",
    "value": 5,
    "lat": -31.8762931,
    "lng": 115.8952097
  },
  {
    "name": "North Coogee",
    "value": 4,
    "lat": -32.0930018,
    "lng": 115.7593892
  },
  {
    "name": "North Dandalup",
    "value": 3,
    "lat": -32.5172772,
    "lng": 115.9671541
  },
  {
    "name": "North Fremantle",
    "value": 12,
    "lat": -32.0327438,
    "lng": 115.7549789
  },
  {
    "name": "North Perth",
    "value": 3,
    "lat": -31.9308627,
    "lng": 115.8567044
  },
  {
    "name": "Northam",
    "value": 1,
    "lat": -31.6535192,
    "lng": 116.6726927
  },
  {
    "name": "Northbridge",
    "value": 5,
    "lat": -31.9478509,
    "lng": 115.8575464
  },
  {
    "name": "Nowergup",
    "value": 16,
    "lat": -31.6384551,
    "lng": 115.7607631
  },
  {
    "name": "O'Connor",
    "value": 4,
    "lat": -32.0595853,
    "lng": 115.7923713
  },
  {
    "name": "Oakford",
    "value": 30,
    "lat": -32.2139266,
    "lng": 115.932983
  },
  {
    "name": "Ocean Reef",
    "value": 6,
    "lat": -31.7586759,
    "lng": 115.73908374929383
  },
  {
    "name": "Oldbury",
    "value": 3,
    "lat": -32.2647214,
    "lng": 115.9240043
  },
  {
    "name": "Onslow",
    "value": 2,
    "lat": -21.6382467,
    "lng": 115.1134438
  },
  {
    "name": "Orange Grove",
    "value": 2,
    "lat": -32.0340334,
    "lng": 116.0234228
  },
  {
    "name": "Orange Springs",
    "value": 1,
    "lat": -31.0054635,
    "lng": 115.6216304
  },
  {
    "name": "Orelia",
    "value": 1,
    "lat": -32.2328272,
    "lng": 115.8233058
  },
  {
    "name": "Osborne Park",
    "value": 14,
    "lat": -31.9033165,
    "lng": 115.814291
  },
  {
    "name": "Padbury",
    "value": 4,
    "lat": -31.8086572,
    "lng": 115.7728199
  },
  {
    "name": "Palmer",
    "value": 4,
    "lat": -33.2914655,
    "lng": 116.2444232602436
  },
  {
    "name": "Palmyra",
    "value": 2,
    "lat": -32.044968,
    "lng": 115.7858881
  },
  {
    "name": "Parkerville",
    "value": 4,
    "lat": -31.8789061,
    "lng": 116.1420759
  },
  {
    "name": "Parklands",
    "value": 1,
    "lat": -32.4954261,
    "lng": 115.7737715
  },
  {
    "name": "Parmelia",
    "value": 2,
    "lat": -32.2466315,
    "lng": 115.8264989
  },
  {
    "name": "Parmila",
    "value": 1,
    "lat": -25.2303005,
    "lng": 121.0187246
  },
  {
    "name": "Pearsall",
    "value": 4,
    "lat": -31.780478,
    "lng": 115.8189561
  },
  {
    "name": "Peppermint Grove Beach",
    "value": 1,
    "lat": -33.5279893,
    "lng": 115.5072495
  },
  {
    "name": "Peron",
    "value": 5,
    "lat": -25.69819415,
    "lng": 113.50723509865874
  },
  {
    "name": "Perth",
    "value": 59,
    "lat": -31.9558967,
    "lng": 115.8605784
  },
  {
    "name": "Perth Airport",
    "value": 66,
    "lat": -31.941521299999998,
    "lng": 115.96557691899352
  },
  {
    "name": "Piara Waters",
    "value": 17,
    "lat": -32.1251145,
    "lng": 115.9178022
  },
  {
    "name": "Picton",
    "value": 7,
    "lat": -33.3415555,
    "lng": 115.70273985671639
  },
  {
    "name": "Picton East",
    "value": 9,
    "lat": -33.3452125,
    "lng": 115.72465453050069
  },
  {
    "name": "Pinjar",
    "value": 3,
    "lat": -32.6318966,
    "lng": 115.869247
  },
  {
    "name": "Pinjarra",
    "value": 5,
    "lat": -32.6318966,
    "lng": 115.869247
  },
  {
    "name": "Port Headland",
    "value": 1,
    "lat": -20.4067607,
    "lng": 118.5785719
  },
  {
    "name": "Port Kennedy",
    "value": 10,
    "lat": -32.3704685,
    "lng": 115.7527396
  },
  {
    "name": "Quinns Rock",
    "value": 1,
    "lat": -31.6698291,
    "lng": 115.6980227
  },
  {
    "name": "Quinns Rocks",
    "value": 3,
    "lat": -31.6698291,
    "lng": 115.6980227
  },
  {
    "name": "Ravenswood",
    "value": 3,
    "lat": -32.5810619,
    "lng": 115.8364923
  },
  {
    "name": "Redcliffe",
    "value": 1,
    "lat": -31.9394531,
    "lng": 115.9420345
  },
  {
    "name": "Regans Ford",
    "value": 1,
    "lat": -30.9831524,
    "lng": 115.7013788
  },
  {
    "name": "Ridgewood",
    "value": 3,
    "lat": -31.6618757,
    "lng": 115.7218372
  },
  {
    "name": "Rivervale",
    "value": 3,
    "lat": -31.9628542,
    "lng": 115.9147434
  },
  {
    "name": "Rockingham",
    "value": 17,
    "lat": -32.2851899,
    "lng": 115.7426524
  },
  {
    "name": "Roelands",
    "value": 1,
    "lat": -33.2924888,
    "lng": 115.8281926
  },
  {
    "name": "Roleystone",
    "value": 4,
    "lat": -32.1123763,
    "lng": 116.0688121
  },
  {
    "name": "Rottenst",
    "value": 1,
    "lat": -25.2303005,
    "lng": 121.0187246
  },
  {
    "name": "Rottnest",
    "value": 1,
    "lat": -32.007009499999995,
    "lng": 115.52052709064799
  },
  {
    "name": "Rottnest Island",
    "value": 10,
    "lat": -32.007009499999995,
    "lng": 115.52052709064799
  },
  {
    "name": "Safety Bay",
    "value": 2,
    "lat": -32.30351795,
    "lng": 115.74025880355309
  },
  {
    "name": "Salter Point",
    "value": 7,
    "lat": -32.0236746,
    "lng": 115.8658082
  },
  {
    "name": "Sawyers Valley",
    "value": 2,
    "lat": -31.9039193,
    "lng": 116.2055141
  },
  {
    "name": "Scarborough",
    "value": 5,
    "lat": -31.8959841,
    "lng": 115.7592114
  },
  {
    "name": "Secret Harbour",
    "value": 1,
    "lat": -32.4009024,
    "lng": 115.7529313
  },
  {
    "name": "Serpentine",
    "value": 2,
    "lat": -32.38592945,
    "lng": 116.05698167818306
  },
  {
    "name": "Seville Grove",
    "value": 1,
    "lat": -32.1360525,
    "lng": 115.9915227
  },
  {
    "name": "Shelley",
    "value": 2,
    "lat": -32.0297125,
    "lng": 115.8866113
  },
  {
    "name": "Shenton Park",
    "value": 3,
    "lat": -31.95930665,
    "lng": 115.8056543072824
  },
  {
    "name": "Shoalwater",
    "value": 6,
    "lat": -32.294628,
    "lng": 115.7111643
  },
  {
    "name": "Singleton",
    "value": 2,
    "lat": -32.4478482,
    "lng": 115.7545664
  },
  {
    "name": "Sorrento",
    "value": 1,
    "lat": -31.8246324,
    "lng": 115.7534097
  },
  {
    "name": "South Bunbury",
    "value": 14,
    "lat": -33.349335999999994,
    "lng": 115.63165446428572
  },
  {
    "name": "South Fremantle",
    "value": 3,
    "lat": -32.0717661,
    "lng": 115.7544513
  },
  {
    "name": "South Guildford",
    "value": 3,
    "lat": -31.910613,
    "lng": 115.9760781
  },
  {
    "name": "South Lake",
    "value": 2,
    "lat": -32.1100323,
    "lng": 115.8455255
  },
  {
    "name": "South Perth",
    "value": 3,
    "lat": -31.9877919,
    "lng": 115.8670301
  },
  {
    "name": "South Yunderup",
    "value": 3,
    "lat": -32.5969174,
    "lng": 115.7969887
  },
  {
    "name": "Southern River",
    "value": 8,
    "lat": -32.0857496,
    "lng": 115.97972271506367
  },
  {
    "name": "Spearwood",
    "value": 3,
    "lat": -32.1042971,
    "lng": 115.7837905
  },
  {
    "name": "St James",
    "value": 3,
    "lat": -31.9490566,
    "lng": 115.8605338
  },
  {
    "name": "Stake Hill",
    "value": 5,
    "lat": -32.4925846,
    "lng": 115.8023317
  },
  {
    "name": "Stirling",
    "value": 16,
    "lat": -31.950651999999998,
    "lng": 115.79787549213657
  },
  {
    "name": "Subiaco",
    "value": 11,
    "lat": -31.94460005,
    "lng": 115.83009980280193
  },
  {
    "name": "Swan View",
    "value": 2,
    "lat": -31.8800199,
    "lng": 116.0471182
  },
  {
    "name": "Swanbourne",
    "value": 6,
    "lat": -31.972904,
    "lng": 115.7666449
  },
  {
    "name": "TBA",
    "value": 1,
    "lat": -25.2303005,
    "lng": 121.0187246
  },
  {
    "name": "Talbot rd",
    "value": 1,
    "lat": -31.8855848,
    "lng": 116.0524212
  },
  {
    "name": "The Lakes",
    "value": 1,
    "lat": -31.876049,
    "lng": 116.3204469
  },
  {
    "name": "The Vines",
    "value": 2,
    "lat": -31.75683,
    "lng": 116.0034
  },
  {
    "name": "Thornlie",
    "value": 6,
    "lat": -32.0473367,
    "lng": 115.9523821
  },
  {
    "name": "Three Springs",
    "value": 1,
    "lat": -29.5330449,
    "lng": 115.7614348
  },
  {
    "name": "Tom Price",
    "value": 1,
    "lat": -22.6892972,
    "lng": 117.7974898
  },
  {
    "name": "Toodyay",
    "value": 1,
    "lat": -31.5511748,
    "lng": 116.4671695
  },
  {
    "name": "Treeby",
    "value": 1,
    "lat": -32.120817,
    "lng": 115.8924972
  },
  {
    "name": "Tuart Hill",
    "value": 8,
    "lat": -31.8986812,
    "lng": 115.8346053
  },
  {
    "name": "Two Rocks",
    "value": 8,
    "lat": -31.6115739,
    "lng": 115.38970031950672
  },
  {
    "name": "Usher",
    "value": 2,
    "lat": -33.3797385,
    "lng": 115.6279544000955
  },
  {
    "name": "Vasse",
    "value": 1,
    "lat": -33.6798667,
    "lng": 115.2417909
  },
  {
    "name": "Victoria Park",
    "value": 9,
    "lat": -31.9780825,
    "lng": 115.90667560855869
  },
  {
    "name": "Wagerup",
    "value": 4,
    "lat": -32.9003365,
    "lng": 115.9233422
  },
  {
    "name": "Waikiki",
    "value": 1,
    "lat": -32.3142076,
    "lng": 115.7557333
  },
  {
    "name": "Wandi",
    "value": 1,
    "lat": -34.0369045,
    "lng": 116.04604436525486
  },
  {
    "name": "Wangara",
    "value": 6,
    "lat": -31.7900584,
    "lng": 115.820817
  },
  {
    "name": "Wanneroo",
    "value": 15,
    "lat": -31.6520862,
    "lng": 115.73927869009182
  },
  {
    "name": "Warnbro",
    "value": 4,
    "lat": -32.3265299,
    "lng": 115.767922
  },
  {
    "name": "Waroona",
    "value": 1,
    "lat": -32.8431317,
    "lng": 115.9260503
  },
  {
    "name": "Warwick",
    "value": 8,
    "lat": -31.8448271,
    "lng": 115.7963953
  },
  {
    "name": "Waterloo",
    "value": 1,
    "lat": -33.326413,
    "lng": 115.7680286
  },
  {
    "name": "Wattle Grove",
    "value": 4,
    "lat": -31.99295,
    "lng": 115.9823
  },
  {
    "name": "Wattleup",
    "value": 9,
    "lat": -32.1677339,
    "lng": 115.8155558
  },
  {
    "name": "Wellard",
    "value": 5,
    "lat": -32.2639959,
    "lng": 115.8170976
  },
  {
    "name": "Wellesley",
    "value": 8,
    "lat": -33.194019,
    "lng": 115.76533597143828
  },
  {
    "name": "Welshpool",
    "value": 15,
    "lat": -31.9921285,
    "lng": 115.9325126
  },
  {
    "name": "Wembley",
    "value": 2,
    "lat": -31.9336484,
    "lng": 115.8148091
  },
  {
    "name": "Wembley Downs",
    "value": 3,
    "lat": -31.9192137,
    "lng": 115.7798863
  },
  {
    "name": "West Leederville",
    "value": 1,
    "lat": -31.935301199999998,
    "lng": 115.8438119268822
  },
  {
    "name": "West Perth",
    "value": 3,
    "lat": -31.9558967,
    "lng": 115.8605784
  },
  {
    "name": "Westminster",
    "value": 1,
    "lat": -31.8670748,
    "lng": 115.838167
  },
  {
    "name": "White Gum Valley",
    "value": 3,
    "lat": -32.0603082,
    "lng": 115.7705674
  },
  {
    "name": "Whiteman Park",
    "value": 1,
    "lat": -31.8358973,
    "lng": 115.9645383
  },
  {
    "name": "Whitfords",
    "value": 1,
    "lat": -31.7993807,
    "lng": 115.7823378
  },
  {
    "name": "Willagee",
    "value": 5,
    "lat": -32.0520262,
    "lng": 115.8052683
  },
  {
    "name": "Willetton",
    "value": 1,
    "lat": -32.0611306,
    "lng": 115.87900335870759
  },
  {
    "name": "Wilson",
    "value": 3,
    "lat": -32.0196968,
    "lng": 115.91165
  },
  {
    "name": "Withers",
    "value": 8,
    "lat": -33.366666,
    "lng": 115.63001305990335
  },
  {
    "name": "Woodbridge",
    "value": 3,
    "lat": -31.8911443,
    "lng": 115.9914378
  },
  {
    "name": "Woodvale",
    "value": 2,
    "lat": -31.7864026,
    "lng": 115.7936906
  },
  {
    "name": "Wooroloo",
    "value": 1,
    "lat": -31.8043698,
    "lng": 116.3136947
  },
  {
    "name": "Worsley",
    "value": 2,
    "lat": -33.296991500000004,
    "lng": 115.9866723256558
  },
  {
    "name": "Wundowie",
    "value": 2,
    "lat": -31.7630699,
    "lng": 116.3868856
  },
  {
    "name": "Wungong",
    "value": 2,
    "lat": -32.1827986,
    "lng": 116.0141611
  },
  {
    "name": "Yanchep",
    "value": 2,
    "lat": -31.5318742,
    "lng": 115.6438253
  },
  {
    "name": "Yangebup",
    "value": 1,
    "lat": -32.1220078,
    "lng": 115.8187448
  },
  {
    "name": "Yarawindah",
    "value": 1,
    "lat": -31.1124895,
    "lng": 116.2596568
  },
  {
    "name": "Yoganup",
    "value": 1,
    "lat": -33.7389145,
    "lng": 115.62844485801338
  },
  {
    "name": "Yokine",
    "value": 4,
    "lat": -31.90171,
    "lng": 115.8525017
  },
  {
    "name": "York",
    "value": 1,
    "lat": -31.8889034,
    "lng": 116.7691483
  },
  {
    "name": "edgewater",
    "value": 2,
    "lat": -31.76322,
    "lng": 115.7818
  },
  {
    "name": "wesley",
    "value": 1,
    "lat": -31.9792623,
    "lng": 115.8660965
  }
];
